import { Calendar, DollarSign, Star, Clock, Gift, Mail, BarChart3, Users } from 'lucide-react';
import { AppConfig, ChaosPosition } from './types';

// App configurations with icons and colors
export const APP_CONFIGS: AppConfig[] = [
  { id: 'calendar', name: 'Calendar', color: '#4285F4', icon: Calendar },
  { id: 'payroll', name: 'Payroll', color: '#00A86B', icon: DollarSign },
  { id: 'reviews', name: 'Reviews', color: '#FFB800', icon: Star },
  { id: 'time-tracking', name: 'Time Tracking', color: '#FF6B35', icon: Clock },
  { id: 'loyalty', name: 'Loyalty', color: '#8B5CF6', icon: Gift },
  { id: 'email', name: 'Email', color: '#EA4335', icon: Mail },
  { id: 'analytics', name: 'Analytics', color: '#14B8A6', icon: BarChart3 },
  { id: 'employees', name: 'Employees', color: '#6366F1', icon: Users },
];

// Viewport units (vw/vh) - cards will scatter visibly across screen
export const CHAOS_POSITIONS: ChaosPosition[] = [
  { x: -35, y: -25, rotation: -12, scale: 0.9 },   // Top left
  { x: -15, y: -28, rotation: 8, scale: 1.0 },     // Top center-left
  { x: 18, y: -24, rotation: -5, scale: 0.85 },    // Top center-right
  { x: 38, y: -18, rotation: 10, scale: 0.95 },    // Top right
  { x: -40, y: 8, rotation: 5, scale: 0.9 },       // Middle left
  { x: 32, y: 12, rotation: -8, scale: 0.9 },      // Middle right
  { x: -28, y: 30, rotation: -10, scale: 0.85 },   // Bottom left
  { x: 12, y: 35, rotation: 6, scale: 1.0 },       // Bottom center
];

export const TIDY_POSITION: ChaosPosition = {
  x: 0, y: 0, rotation: 0, scale: 1.0
};

export const BENEFITS = [
  { stat: '10+', unit: 'hours/week', title: 'Time Saved', description: 'Stop switching between tools and syncing data manually' },
  { stat: '60%', unit: 'less', title: 'Cost Reduction', description: 'Replace multiple subscriptions with one affordable platform' },
  { stat: '8', unit: 'tools → 1', title: 'Single Platform', description: 'All your business data accessible in one place, no exports needed' },
];

export const ANIMATION_CONFIG = {
  chaosToTidyDuration: [0, 0.4] as [number, number],        // Scroll range for card movement
  fadeOutCards: [0.38, 0.45] as [number, number],           // Cards fade out
  fadeInMergedCard: [0.38, 0.45] as [number, number],       // Merged card fades in
  holdMergedCard: [0.45, 0.55] as [number, number],         // Merged card stays visible
  fadeOutMergedCard: [0.55, 0.62] as [number, number],      // Merged card fades out
  showBenefits: 0.55,                                        // Benefits appear as logo fades
  scrollOffset: ["start start", "end end"] as [string, string],
};
